import { createRequest, RequestConfig } from 'app/common/api';

import { TProfileConstraints } from '../core/profile-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_terminal_profiles',
};

export const getProfilesRequest = (constraints?: TProfileConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
